module.exports = __webpack_public_path__ + "static/106.0ff5e404.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/screenshots/106.png
// module id = 471
// module chunks = 35783957827783